import find from 'lodash/find';
import noop from 'lodash/noop';
import { defaultLocale } from '@atlassian/jira-common-constants/src/supported-locales';
import type { FieldValidationError } from '@atlassian/jira-fetch/src/utils';

import { toProjectKey } from '@atlassian/jira-shared-types';
import { PROJECT_DEFAULT } from '../../common/constants/default-assignee';

import {
	SET_APP_PROPS,
	SAVE,
	UPDATE,
	CANCEL,
	SUCCESS,
	VALIDATION_FAILURE,
	FAILURE,
	type Action,
} from './actions';
import type { State } from './types';

const defaultState: State = {
	appProps: {
		baseUrl: '',
		locale: defaultLocale,
		projectId: NaN,
		projectKey: toProjectKey(''),
		projectDefaultAssignee: undefined,
		projectLead: undefined,
		onClose: noop,
		onComplete: noop,
		onError: noop,
	},
	isSaving: false,
	component: {
		name: '',
		description: '',
		defaultAssignee: PROJECT_DEFAULT,
		lead: undefined,
	},
	errors: {
		name: '',
		componentLead: '',
	},
};

const getFieldError = (payload: FieldValidationError[], field: string): string => {
	const result = find(payload, { field }) || {};
	// @ts-expect-error - TS2339 - Property 'error' does not exist on type '{}'.
	return result.error || '';
};

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (state: State = defaultState, action: Action): State => {
	switch (action.type) {
		case SET_APP_PROPS: {
			return {
				...state,
				appProps: action.payload,
			};
		}
		case UPDATE: {
			return {
				...state,
				component: action.payload,
			};
		}
		case SAVE: {
			return {
				...state,
				isSaving: true,
				errors: {
					name: '',
					componentLead: '',
				},
			};
		}
		case VALIDATION_FAILURE: {
			return {
				...state,
				isSaving: false,
				errors: {
					name: getFieldError(action.payload, 'name'),
					componentLead: getFieldError(action.payload, 'componentLead'),
				},
			};
		}
		case FAILURE:
		case CANCEL:
		case SUCCESS: {
			return {
				...state,
				isSaving: false,
			};
		}
		default: {
			const _exhaustiveCheck: never = action;
			return state;
		}
	}
};
